import VueRouter from 'vue-router'
import { Forbidden, NotFound, Welcome } from './components'
import { Login, Register } from './components/auth'
import { Inbox } from './components/inbox'
import { LiveClass } from './components/liveclass'
import { Reward } from './components/reward'
import { Ranking } from './components/ranking'
import { Subject , LessonDetail, FlexDetail, LessonPackage, TestDetail} from './components/subject'
import { PreviewCourse, PreviewLesson, PreviewLessonPackage, TestDetailPreview} from './components/reviewsubject'
import { Profile } from './components/profile'
import { Assignment } from './components/assignment'
import { Todolist } from './components/todolist'
import  Gradebook  from './components/gradebook/gradebook.vue'


import { store } from './store'
import Policy from './components/policy/policy.vue'

const router = new VueRouter({
    mode: 'history',
    routes: [
        { path: '/home', name: 'home', component: Welcome },
        { path: '/privacypolicy', name: 'policy', component: Policy,meta: { layout: 'auth-layout' }},
        { path: '/', name: 'login', component: Login, meta: { layout: 'auth-layout' }},
        // { path: '/login', name: 'login', component: Login, meta: { layout: 'auth-layout' }},
        { path: '/register', name: 'register', component: Register, meta: { layout: 'auth-layout' }},
        { path: '/inbox', name: 'inbox', component: Inbox},
        { path: '/liveclass', name: 'liveclass', component: LiveClass},
        { path: '/todo-list', name: 'todolist', component: Todolist, meta: { layout: 'empty-layout' }},
        { path: '/gradebook/:class_id', name: 'gradebook', component: Gradebook, meta: { layout: 'empty-layout' },props: true},
        { path: '/assignment', name: 'assignment', component: Assignment, meta: { layout: 'empty-layout' }},
        { path: '/reward/:name_challenge', name: 'reward', component: Reward},
        { path: '/ranking', name: 'ranking', component: Ranking},
        { path: '/profile', name: 'profile', component: Profile},
        { path: '/lesson/:class_id/:course_id-:module_id-:lesson_id-:lesson_package_id-:item_id-:feedback_noti_id', name: 'lesson_detail', component: LessonDetail, meta: { layout: 'empty-layout' },  props: true,},
        { path: '/flex', name: 'flex_detail', component: FlexDetail, meta: { layout: 'empty-layout' },  props: true,},
        { path: '/test-module', name: 'test_detail', component: TestDetail, meta: { layout: 'empty-layout' },  props: true,},
        { path: '/subject/:course_id/:class_id', name: 'subject', component: Subject,  meta: { layout: 'empty-layout' }},
        { path: '/lesson-package/:class_id/:course_id-:module_id-:lesson_id', name: 'lesson-package', component: LessonPackage,  meta: { layout: 'empty-layout' }, props: true},
        { path: '/preview-course', name: 'PreviewCourse', component: PreviewCourse,  meta: { layout: 'preview-layout' }},
        { path: '/preview-lesson', name: 'preview-lesson', component: PreviewLesson,  meta: { layout: 'preview-layout' }},
        { path: '/preview-lesson-package', name: 'preview-lesson-package', component: PreviewLessonPackage,  meta: { layout: 'preview-layout' },  props: true,},
        { path: '/test-module-preview', name: 'test_detail_preview', component: TestDetailPreview, meta: { layout: 'preview-layout' },  props: true,},

        // { path: '/preview-module/:module_id', name: 'PreviewModule', component: PreviewCourse,  meta: { layout: 'empty-layout' }},

        { path: '/404', name: 'not_found', component: NotFound },
        { path: '/403', name: 'forbidden', component: Forbidden },

        { path: '*', component: { default: NotFound, helper: NotFound }, meta: { layout: 'error-layout' } }
    ],
    scrollBehavior(to, from, savedPosition) {
        return {
            x: 0,
            y: 0,
        };
    }
});

router.beforeResolve((to, from, next) => {
    // If this isn't an initial page load.
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters.isLoggedIn) {
            //store.dispatch("SET_USER_INFO");
            store.commit('setLoading', true);
            next();
            return
        }
        //next('/register-anomynous')
    }
    //store.commit("setLoading", true);
    if (to.name) {
        // Start the route progress bar.
    }

    next()
});

router.afterEach((to, from) => {
    store.commit('setLoading', false);
    
    // Google Analytics detailed tracking
    if (typeof gtag !== 'undefined') {
        const GA_ID = process.env.VUE_APP_GA_ID;
        
        // Basic page view data
        const trackingData = {
            page_title: to.name || to.path,
            page_location: window.location.href,
            page_path: to.path,
            from_path: from.path,
            route_name: to.name,
            route_params: to.params,
            route_query: to.query,
            layout: to.meta.layout || 'default',
            timestamp: new Date().toISOString(),
            ga_id: GA_ID
        };
        
        console.log('GA Tracking - Detailed page view:', trackingData);
        
        // Send page view
        gtag('config', GA_ID, {
            page_title: trackingData.page_title,
            page_location: trackingData.page_location,
            page_path: trackingData.page_path,
            custom_map: {
                'custom_parameter_1': 'route_name',
                'custom_parameter_2': 'layout'
            }
        });
        
        // Track route change as custom event
        gtag('event', 'page_view', {
            event_category: 'navigation',
            event_label: to.name || to.path,
            custom_parameter_1: to.name,
            custom_parameter_2: to.meta.layout || 'default',
            value: 1
        });
        
        // Track specific route types
        if (to.path.includes('/lesson/')) {
            gtag('event', 'lesson_access', {
                event_category: 'learning',
                event_label: 'lesson_view',
                lesson_id: to.params.lesson_id || 'unknown',
                course_id: to.params.course_id || 'unknown',
                class_id: to.params.class_id || 'unknown'
            });
        }
        
        if (to.path.includes('/test-module')) {
            gtag('event', 'test_access', {
                event_category: 'assessment',
                event_label: 'test_view',
                test_type: to.path.includes('preview') ? 'preview' : 'actual'
            });
        }
        
        if (to.path.includes('/subject/')) {
            gtag('event', 'subject_access', {
                event_category: 'learning',
                event_label: 'subject_view',
                course_id: to.params.course_id || 'unknown',
                class_id: to.params.class_id || 'unknown'
            });
        }
        
        if (to.name === 'login' || to.name === 'register') {
            gtag('event', 'auth_page_visit', {
                event_category: 'authentication',
                event_label: to.name,
                page_type: 'auth'
            });
        }
        
        // Track user flow - session duration on previous page
        if (from.path && from.path !== to.path) {
            const sessionKey = `page_start_${from.path.replace(/[^a-zA-Z0-9]/g, '_')}`;
            const pageStartTime = sessionStorage.getItem(sessionKey);
            
            if (pageStartTime) {
                const timeSpent = Date.now() - parseInt(pageStartTime);
                gtag('event', 'page_timing', {
                    event_category: 'engagement',
                    event_label: from.path,
                    value: Math.round(timeSpent / 1000), // Convert to seconds
                    custom_parameter_1: from.name || 'unknown'
                });
                sessionStorage.removeItem(sessionKey);
            }
        }
        
        // Store current page start time
        const currentSessionKey = `page_start_${to.path.replace(/[^a-zA-Z0-9]/g, '_')}`;
        sessionStorage.setItem(currentSessionKey, Date.now().toString());
        
    } else {
        console.warn('GA Debug - gtag is not available', {
            to_path: to.path,
            from_path: from.path,
            route_name: to.name
        });
    }
});

export default router;